import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowDownIcon, MenuIcon, MoonIcon, SunIcon, XIcon } from "../icons/Icons";

export default function Header({ isLight, setIsLight }) {
  const [open, setOpen] = useState(false);

  const navItems = [
    { label: "About", href: "#about" },
    { label: "Experience", href: "#experience" },
    { label: "Projects", href: "#projects" },
    { label: "Skills", href: "#skills" },
    { label: "Education", href: "#education" },
    { label: "AI Agent", href: "#agent" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <header className="sticky top-0 z-40 backdrop-blur supports-[backdrop-filter]:bg-white/5 border-b border-white/5">
      <nav className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        {/* Logo */}
        <a href="#home" className="font-semibold tracking-tight hover:text-cyan-500 transition">
          David Iguta
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6 text-sm">
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className="hover:text-cyan-500 transition">
              {item.label}
            </a>
          ))}
          <a
            href="/cv.pdf"
            download
            className="inline-flex items-center gap-2 rounded-xl border border-white/10 px-3 py-1.5 hover:border-emerald-300/60 transition"
          >
            <ArrowDownIcon className="w-4 h-4" /> CV
          </a>
          <button
            onClick={() => setIsLight((v) => !v)}
            className="inline-flex items-center gap-2 rounded-xl border border-white/10 px-3 py-1.5 hover:border-cyan-300/60 transition"
            aria-pressed={isLight}
          >
            {isLight ? <SunIcon className="w-4 h-4" /> : <MoonIcon className="w-4 h-4" />}
            <span className="hidden lg:inline">{isLight ? "Light" : "Dark"}</span>
          </button>
        </div>

        {/* Mobile Nav Button */}
        <div className="md:hidden">
          <button
            onClick={() => setOpen((v) => !v)}
            className="p-2 rounded-xl border border-white/10 hover:border-cyan-300/60"
            aria-label="Toggle menu"
          >
            {open ? <XIcon className="w-5 h-5" /> : <MenuIcon className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {/* Mobile Dropdown with Animation */}
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.25 }}
            className={`md:hidden absolute right-4 top-16 w-56 rounded-2xl shadow-lg z-50 p-3 space-y-2 border 
              ${isLight ? "bg-white border-slate-200 text-slate-900" : "bg-slate-950 border-white/10 text-slate-100"}`}
          >
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={`block px-3 py-2 rounded-xl transition ${
                  isLight ? "hover:bg-slate-100 hover:text-cyan-600" : "hover:bg-white/5 hover:text-cyan-300"
                }`}
                onClick={() => setOpen(false)}
              >
                {item.label}
              </a>
            ))}
            <a
              href="/cv.pdf"
              download
              className={`block px-3 py-2 rounded-xl transition ${
                isLight ? "hover:bg-slate-100 hover:text-emerald-600" : "hover:bg-white/5 hover:text-emerald-300"
              }`}
              onClick={() => setOpen(false)}
            >
              Download CV
            </a>
            <button
              onClick={() => {
                setIsLight((v) => !v);
                setOpen(false);
              }}
              className={`w-full text-left px-3 py-2 rounded-xl transition ${
                isLight ? "hover:bg-slate-100 hover:text-cyan-600" : "hover:bg-white/5 hover:text-cyan-300"
              }`}
            >
              Toggle {isLight ? "Dark" : "Light"} Mode
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
